export default "/images/vendor/flag-icon-css/flags/4x3/ao.svg?39110f8b63c8b1d373b192ebb7fc9ff8";